import { InfoIcon } from "lucide-react"
import React from "react"

import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui"

/**
 * Props for DisplayInfo component
 */
export interface DisplayInfoProps {
  title: string
  value?: string | number
  tooltip?: string
}

/**
 * Display a statistic with a title and value in a card format
 * Used for showing metrics like followers, views, etc.
 */
export const DisplayInfo: React.FC<DisplayInfoProps> = ({ title, value, tooltip }) => (
  <div className="flex flex-col items-center justify-center p-3 rounded-md text-center bg-white">
    <div className="text-base font-bold text-slate-900 mb-1">{value}</div>
    <div className="flex items-center gap-1 justify-center">
      <div className="text-xs font-medium text-slate-600">{title}</div>
      {!!tooltip && (
        <Popover>
          <PopoverTrigger>
            <InfoIcon size={16} color="gray" />
          </PopoverTrigger>
          <PopoverContent>
            <p className="text-xs text-black font-normal">{tooltip}</p>
          </PopoverContent>
        </Popover>
      )}
    </div>
  </div>
)

/**
 * Props for MetricRow component
 */
export interface MetricRowProps {
  label: string
  value?: string | number
}

/**
 * Display a metric as a horizontal row with label and value
 * Used for detailed statistics in a list format
 */
export const MetricRow: React.FC<MetricRowProps> = ({ label, value }) => (
  <div className="flex items-center justify-between py-1">
    <span className="text-xs text-slate-600">{label}</span>
    <span className="text-sm font-semibold text-slate-900">{value ?? "_ _"}</span>
  </div>
)
